import { useGetProgressQuery } from "../progressSlice";

const useProgressPage = () => {
  const progress = useGetProgressQuery();
  return { progress: progress?.data || [], progressLoading: progress?.isLoading };
};

export default useProgressPage;
